import { IS_DEVELOPMENT, IS_STAGING } from 'configs'

export const PORTAL_ID = IS_DEVELOPMENT || IS_STAGING ? '44201863' : '43564049'
export const SIGN_UP_FORM_ID =
  IS_DEVELOPMENT || IS_STAGING ? '897b70e8-6708-43e2-83a2-25e0638a86e5' : '9db5a558-08e0-4120-a652-5ea5361774fd'
